import { styled } from '@mui/material'

export const SWrapper = styled('div')`
    display: flex;
    gap: 20px;
    align-items: center;
`
